import { styled, Box } from '@mui/material';

import LoadingFallback from '~components/LoadingFallback';

export const DashboardVariantV2CarrierContentCollectTabTrackingMapContainer =
  styled(Box)(({ theme }) => ({
    width: '65%',
    height: '100%',
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
  }));

export const DashboardVariantV2CarrierContentCollectTabTrackingMapLoading =
  styled(LoadingFallback)({
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    position: 'absolute',
    zIndex: 4,
    inset: 0,
  });
